import { AdminApp } from "./pages/AdminApp";
import { PublicUpload } from "./pages/PublicUpload";

export function App() {
  const path = location.pathname.replace(/\/+$/, "") || "/";
  if (path.startsWith("/admin")) return <AdminApp/>;
  const token = path.match(/^\/p\/([^/]+)/)?.[1] || "demo-project";
  return <PublicUpload token={decodeURIComponent(token)}/>;
}
